import {
  getSelectDropdownListFloatingConfig,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY_WITH_SELECT_ALL,
} from '../../Select'

export const BUILDING_MULTI_SELECT_DROPDOWN_FLOATING_CONFIG_SELECT_ALL =
  getSelectDropdownListFloatingConfig(
    SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY_WITH_SELECT_ALL
  )
